import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from "react";
import ScrollToTopButton from "./Components/ScrollToTopButton";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import Technologies from "./Pages/Technologies";
import ProjectHandler from "./Pages/ProjectHandler";
import { projectDetails } from "./Details";
function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/technologies" element={<Technologies />} />
        {React.Children.toArray(
          projectDetails.map((value, index) => (
            <Route
              path={"/projects/project-" + (index + 1)}
              element={<ProjectHandler />}
            />
          ))
        )}
      </Routes>
      <ScrollToTopButton />
      <Footer />
    </Router>
  );
}
export default App;
